WL.registerComponent(
	"mobile-active-switch",
	{
		affectChildren: { type: WL.Type.Bool, default: true },
	},
	{
		start: function () {
			this.components = [];
			this.getComponents(this.object);
			if (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {
				this.setComponentsActive(true);
				console.log(this.components);
			}

			window.isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
		},

		getComponents: function (obj) {
			const comps = obj
				.getComponents()
				.filter((c) => c.type != "mobile-active-switch");
			this.components = this.components.concat(comps);

			if (this.affectChildren) {
				let children = obj.children;
				for (let i = 0; i < children.length; ++i) {
					this.getComponents(children[i]);
				}
			}
		},

		setComponentsActive: function (active) {
			const comps = this.components;
			for (let i = 0; i < comps.length; ++i) {
				comps[i].active = active;
			}
		},
	}
);
